import React from "react";
import LocationSvg from "./icons/location.svg";
import { formatCheckinDate } from "../../utils/util";

function HotelCard(props) {
  const { data } = props;
  return (
    <div className="hotel-lists mt-8 flex items-center gap-3 border-gray-700  border-b-[1px] pb-6">
      <img className="bg-gray-300 rounded" src={data?.image}  style={{ height: "80px", width:"100px", objectFit: "cover" }}/>
      <div className="flex flex-col gap-2">
        <div className="title">{data?.restaurantName}</div>
        <div className="flex items-center gap-1">
          <img src={LocationSvg} alt="d" />
          <div className="place">{data?.address}</div>
        </div>
        <div className="date">{formatCheckinDate(data?.dateIn) }<span className="mx-2">-</span>{formatCheckinDate(data?.dateOut) }</div>
       </div>
    </div>
  );
}

export default HotelCard;
